import { css } from '@emotion/react';
import { theme } from 'global';

export const textField = css`
  margin: 16px 0;
  min-width: 148px;
`;

export const renderValueContainer = css`
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const labelChip = css`
  margin-right: 2px;
`;

export const menuItem = css`
  display: flex;
  justify-content: space-between;
`;

export const checkboxBox = css`
  box-shadow: 0 0 0 1px inset ${theme.colors.boxshadow};
  width: 16px;
  height: 16px;
  margin: 0 8px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
